import { useAccount } from "wagmi";
import {
	useActiveFarmSessions,
	useMissionHistory,
	usePointsToVoid,
	usePreTGEStatus,
	useShipBalance,
	useUserPoints,
} from "../../hooks";
import { ConnectPrompt } from "../shared/ConnectPrompt";
import { PageLayout } from "../shared/PageLayout";
import { ActiveMissions } from "./ActiveMissions";
import { ClaimSection } from "./ClaimSection";
import { MissionHistory } from "./MissionHistory";
import { PointsDashboard } from "./PointsDashboard";

interface MissionsPageProps {
	onClose?: () => void;
}

export function MissionsPage({ onClose }: MissionsPageProps) {
	const { address, isConnected } = useAccount();
	const { tgeComplete, isLoading: isTgeLoading } = usePreTGEStatus();
	const { points, formattedPoints, hasClaimed, refetch: refetchPoints } = useUserPoints(address);
	const { formattedVoid } = usePointsToVoid(points);
	const { balance: shipBalance } = useShipBalance(address);
	const { activeSessions, isLoading: isSessionsLoading } = useActiveFarmSessions(address);
	const { missions, isLoading: isHistoryLoading } = useMissionHistory(address);

	return (
		<PageLayout
			title="Mission Control"
			subtitle="Track your active missions, history, and accumulated points"
			onClose={onClose}
		>
			{!isConnected ? (
				<ConnectPrompt message="Connect your wallet to view your missions" />
			) : (
				<>
					<PointsDashboard
						formattedPoints={formattedPoints}
						formattedVoid={formattedVoid}
						shipCount={shipBalance}
					/>

					<ActiveMissions sessions={activeSessions} isLoading={isSessionsLoading} />

					<MissionHistory missions={missions} isLoading={isHistoryLoading} />

					{!isTgeLoading && tgeComplete && (
						<ClaimSection
							points={points}
							formattedPoints={formattedPoints}
							formattedVoid={formattedVoid}
							hasClaimed={hasClaimed}
							onClaimed={refetchPoints}
						/>
					)}
				</>
			)}
		</PageLayout>
	);
}
